var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"attachmentWarningToolTip"},[_c('p',{staticClass:"toolTipText"},[_vm._v("* "+_vm._s(_vm.i18n.t('attachmentWarning')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }